import { TRANSLATIONS_APP_NAME, TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { formatPrice } from '../../../../util/PriceUtil';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { getCampaignByCodeFromWpConf, getDiscountPreText, getDiscountPrice, getPriceSuffix } from '../util/InternetOfferPriceUtil';
import { CardBottomPrices } from '@telia-common-components/shared';
const InternetOfferPrice = (props) => {
    var _a, _b;
    const { offer, inModal } = props;
    const { translate, translateOrEmpty } = React.useContext(TranslationsContext);
    const { internetCalculatorConfigState, isSecureNet } = useInternetCalculator();
    const campaignsFromWpConf = (_a = internetCalculatorConfigState === null || internetCalculatorConfigState === void 0 ? void 0 : internetCalculatorConfigState.config) === null || _a === void 0 ? void 0 : _a.campaigns;
    const discountCampaigns = (_b = offer.discounts) === null || _b === void 0 ? void 0 : _b.filter((d) => d.campaignCode);
    if (!offer.price && !offer.priceWithoutVat && offer.properties.includes('PLANNED')) {
        return null;
    }
    return (React.createElement(CardBottomPrices, { regularPrice: `${formatPrice(+(isSecureNet ? offer.priceWithoutVat : offer.price))} ${getPriceSuffix(isSecureNet, translate)}`, discounts: discountCampaigns === null || discountCampaigns === void 0 ? void 0 : discountCampaigns.map((d, index) => {
            var _a, _b, _c;
            return ({
                price: getDiscountPrice(d, getCampaignByCodeFromWpConf(d === null || d === void 0 ? void 0 : d.campaignCode, campaignsFromWpConf), isSecureNet, translate, offer),
                id: (_a = d.priceId) === null || _a === void 0 ? void 0 : _a.toString(),
                tooltipText: translateOrEmpty(TRANSLATIONS_APP_NAME, (_b = getCampaignByCodeFromWpConf(d.campaignCode, campaignsFromWpConf)) === null || _b === void 0 ? void 0 : _b.tooltipText),
                preText: getDiscountPreText(d, index, getCampaignByCodeFromWpConf(d === null || d === void 0 ? void 0 : d.campaignCode, campaignsFromWpConf), translate),
                conditionsLink: inModal
                    ? translateOrEmpty(TRANSLATIONS_APP_NAME, (_c = getCampaignByCodeFromWpConf(d === null || d === void 0 ? void 0 : d.campaignCode, campaignsFromWpConf)) === null || _c === void 0 ? void 0 : _c.conditionsPdf)
                    : null
            });
        }) }));
};
export default InternetOfferPrice;
